import PropertyVerifiedModal from './PropertyVerifiedModal';

export default PropertyVerifiedModal;
